"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UssVod = void 0;
var axios_1 = require("axios");
var types_1 = require("./types");
var Uploader_1 = require("./Uploader");
var USS_1 = require("./USS");
var utils_1 = require("./utils");
var package_json_1 = require("../package.json");
var report_1 = require("./report");
var UssVod = /** @class */ (function () {
    function UssVod(options) {
        this.cancelToken = axios_1.default.CancelToken.source();
        this.uss = new USS_1.USS(__assign(__assign({}, options), { sliceSize: options.sliceSize }));
        if (!options.skipReport) {
            this.reportOption = {
                country: options.country,
                biz: options.biz,
                env: options.env,
                vid: options.vid,
                sdkVersion: 'uss-' + UssVod.version,
                serviceId: 'shopeeuss',
                serviceIndex: options.serviceIndex
            };
        }
    }
    UssVod.prototype.upload = function (params) {
        if (params.coverFile && !utils_1.isImage(params.coverFile)) {
            throw new utils_1.Error({
                code: types_1.ErrorCode.PublishResultCoverInvalid,
                message: 'Publish result cover invalid.'
            });
        }
        return new Uploader_1.UssVodUploader(__assign(__assign({}, params), { cancelToken: axios_1.default.CancelToken.source(), uss: this.uss, report: this.reportOption ? new report_1.Report(this.reportOption) : undefined }));
    };
    UssVod.version = package_json_1.version;
    return UssVod;
}());
exports.UssVod = UssVod;
